import type { Agent } from 'alice-bob'
import { getSharedWorkerPort, MonoParam } from 'monolang'
import { SchedulerTargetNode } from 'scheduler-node/target-node'
import type { MonoProcessor } from './mono-processor'
export { MonoParam }

export type MonoNodeOptions = AudioWorkletNodeOptions & {
  numberOfInputs: number
  numberOfOutputs: number
  outputChannelCount: number[]
  channelCount: number
}

export class MonoNode extends SchedulerTargetNode {
  static registeredContexts = new Set<BaseAudioContext>()

  state: 'disabled' | 'suspended' | 'running' = 'running'

  static async register(context: BaseAudioContext) {
    if (this.registeredContexts.has(context)) return
    await context.audioWorklet.addModule(
      // @ts-ignore
      new URL('./mono-processor.js', import.meta.url).href
    )
    this.registeredContexts.add(context)
  }

  static async create(
    context: BaseAudioContext,
    options: MonoNodeOptions,
  ) {
    await this.register(context)
    const node = new this(context, options)
    await node.init()
    return node
  }

  programParams: Map<number, MonoParam[]> = new Map()

  declare worklet: Agent<MonoProcessor, MonoNode>

  constructor(
    public context: BaseAudioContext,
    public options: MonoNodeOptions,
  ) {
    super(context, 'mono', options)
    const port = getSharedWorkerPort()
    this.worklet.setPort(port)
  }

  disable() {
    this.state = 'disabled'
    this.worklet.disable()
    this.dispatchEvent(new CustomEvent('disable'))
  }

  fetchSample = async (_sample: number): Promise<Float32Array[] | undefined> => void 0

  // setSampleBuffer(index: number, buffer: Float32Array[], range?: [number, number]) {
  //   return await this.worklet.setSampleBuffer(index, buffer, range)
  // }

  // async setSampleBufferRange(index: number, range: [number, number]) {
  //   return await this.worklet.setSampleBufferRange(index, range)
  // }

  public code?: string

  // async receiveParams(params: MonoParam[]) {
  //   this.vmParams = params.map((x: MonoParam) => new MonoParam(x))
  //   this.vmParamsMap.clear()

  //   for (const [i, x] of this.vmParams.entries()) {
  //     // const param = this.sortedParams[i][1]

  //     // // TODO: use error.cause with param index
  //     // const paramValue = x.normalValue * 2 - 1
  //     // if (paramValue > param.maxValue || paramValue < param.minValue)
  //     //   throw new Error(`Default value "${x.defaultValue}" not in range [${x.minValue}..${x.maxValue}]`)

  //     // param.value = paramValue
  //     // this.vmParamsMap.set(x, param)
  //     this.params.set(x.id.toString(), { monoParam: x, audioParam: null } as any)
  //   }
  // }

  async setCode(programNumber: number, code: string) {
    this.code = code
    const result = await this.worklet.setCode(programNumber, code)
    this.programParams.set(programNumber, result.params)
    return result

    // try {
    //   // if (reset) {
    //   //   this.schedulerTarget.midiQueue.clear()
    //   // }


    //   // if (reset) {
    //   //   this.schedulerTarget.midiQueue.clear()
    //   // }

    //   // await this.worklet.initParams()

    //   // return {
    //   //   inputChannels,
    //   //   outputChannels
    //   // }
    // } catch (error) {
    //   // this.vmParams = void 0
    //   // this.vmParamsMap.clear()
    //   throw error
    // }
  }

  // setParamsTargetProgram(paramsTargetProgram: Uint8Array) {
  //   return this.worklet.setParamsTargetProgram(paramsTargetProgram)
  // }

  setClockBuffer(clockBuffer: Float64Array) {
    return this.worklet.setClockBuffer(clockBuffer)
  }

  restartMem(programNumber: number) {
    return this.worklet.restartMem(programNumber)
  }

  suspend() {
    this.state = 'suspended'
    this.worklet.suspend()
    this.dispatchEvent(new CustomEvent('suspend'))
  }

  resume() {
    this.state = 'running'
    this.worklet.resume()
    this.dispatchEvent(new CustomEvent('resume'))
  }

  async resetProgram(programNumber: number) {
    await this.worklet.resetError()
    await this.worklet.resetProgram(programNumber)
  }

  async test(frame: number, length: number, ...params: any[]) {
    return this.worklet.test(frame, length)
  }
}
